module.exports = __webpack_public_path__ + "img/faq-o.2d144a6d.svg";